<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <a class="navbar-brand" routerLink="/home">Maintenance Tracker</a>
  <button class="navbar-toggler" type="button" (click)="navbarCollapsed = !navbarCollapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" [ngbCollapse]="navbarCollapsed">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" routerLink="/home">Home</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/fleet">Fleet</a>
      </li>
    </ul>
    @if (loggedIn) {
      <button class="btn btn-secondary" type="submit" (click)="logout()">
        <fa-icon [icon]="faSignOutAlt"></fa-icon>
      </button>
    }
  </div>
</nav>

<div class="container">
  <router-outlet></router-outlet>

  <footer id="footer">
    <div class="row">
      <div class="col">
        <ul class="list-unstyled">
          <li class="float-lg-right"><a href="javascript:void(0);" onclick="window.scrollTo(0,0)">Back to top</a></li>
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
          <li><a routerLink="/feedback">Feedback</a></li>
        </ul>
      </div>
    </div>
  </footer>
</div>
